<script lang="ts" setup>
const props = defineProps({
  criteria: {
    type: Object as PropType<CriteriaInstance>,
    required: true,
  },
  paragraphPositionData: {
    type: Array as PropType<ParagraphPositionData[]>,
    default: [],
  },
});

const documentId = inject("documentId") as any;
const documentChecklistStore = useDocumentChecklistStore(documentId);
const { useAllChecklistCriteria } = storeToRefs(documentChecklistStore);

const label = computed(() => {
  if (
    props.criteria.checklistCriteriaId == undefined &&
    props.criteria.labelOverride
  ) {
    return props.criteria.labelOverride;
  }

  const criteria = useAllChecklistCriteria.value?.find(
    (c) => c.id === props.criteria.checklistCriteriaId
  );
  return criteria?.label ?? "N/A";
});

const isCustomCriteira = computed(() => {
  return props.criteria.checklistCriteriaId == undefined;
});

const positionData = computed(() => {
  return props.criteria.paragraphPositionsData ?? props.paragraphPositionData;
});

const positionScore = computed(() => {
  return (position: ParagraphPositionData) => {
    if (position.manualScore != undefined) {
      return position.manualScore;
    }

    if (position.score != undefined) {
      return position.score;
    }

    return 0;
  };
});
</script>

<template>
  <tr class="border-b last:border-none">
    <td class="border-r"></td>
    <td
      class="border-r px-2 py-1"
      :class="{
        ' text-right text-danger-default': isCustomCriteira,
      }"
    >
      {{ label }}
    </td>
    <td
      v-if="criteria.evaluationMethod != 'paragraph' && criteria.maxPoints != undefined && criteria.maxPoints > 0"
      class="text-center px-2 py-1 whitespace-nowrap"
      :class="{
        ' text-danger-default': isCustomCriteira,
      }"
    >
      <span>
        {{ criteria.earnedPoints ?? 0 }}
      </span>
      <span v-if="criteria.maxPoints != undefined">/</span>
      <span v-if="criteria.maxPoints != undefined && criteria.maxPoints > 0">
        {{ criteria.maxPoints }}
      </span>
    </td>
    <td
      v-if="
        criteria.evaluationMethod == 'paragraph' && positionData != undefined
      "
      class="text-center whitespace-nowrap"
      :class="{
        ' text-danger-default': isCustomCriteira,
      }"
    >
      <table class="w-full">
        <tr>
          <td
            v-for="position in positionData"
            class="border-r last:border-none text-center px-2 py-1 whitespace-nowrap"
          >
            <span v-if="criteria.pointsPerInstance > 0">
              {{ positionScore(position) }}/{{ criteria.pointsPerInstance }}
            </span>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</template>

<style scoped></style>
